import { z } from "zod";

/** Request body for getDiscoveryUsers callable */
export const GetDiscoveryUsersRequestSchema = z.object({
  limit: z.number().int().positive().optional(),
  startWithUserId: z.string().min(1).optional(),
});

export type GetDiscoveryUsersRequest = z.infer<typeof GetDiscoveryUsersRequestSchema>;

/** Request body for getPublicUserProfiles callable */
export const GetPublicUserProfilesRequestSchema = z.object({
  uids: z.array(z.string().min(1)).min(1).max(50),
});

export type GetPublicUserProfilesRequest = z.infer<typeof GetPublicUserProfilesRequestSchema>;

/** Request body for handleLike callable */
export const HandleLikeRequestSchema = z.object({
  likedUserId: z.string().min(1),
});

export type HandleLikeRequest = z.infer<typeof HandleLikeRequestSchema>;
